import { configureStore } from '@reduxjs/toolkit';

import pageAboutReducer from './pages/about/pageAboutSlice';

export const store = configureStore({
    reducer: {
        pageAbout: pageAboutReducer
    }
});